import { Select as SelectAntd, SelectProps as SelectPropsAntd, Skeleton, Spin } from 'antd';
import { ArrowDownIcon, LoupIcon } from 'assets';
import { debounce } from 'lodash';
import { useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
export type SelectProps = SelectPropsAntd & {
  onLoadMore?: () => void;
  hasMore?: boolean;
  prefix?: React.ReactNode;
};
const Select = ({ onSearch, onLoadMore, hasMore, loading, prefix, ...props }: SelectProps) => {
  const debouncedOnSearch = useCallback(
    debounce((keywordValue: string) => {
      onSearch?.(keywordValue);
    }, 200),
    [onSearch]
  );

  const handleSearch = (val: string) => {
    debouncedOnSearch(val);
  };

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      onLoadMore?.();
    }
  };
  if (prefix) {
    return (
      <div className={twMerge('relative flex h-10 items-center pl-4', props.className)}>
        {prefix}
        <SelectAntd
          {...props}
          dropdownRender={
            props?.dropdownRender
              ? props.dropdownRender
              : (menu) => {
                  return (
                    <div>
                      {menu}
                      {loading && <Skeleton active title={false} paragraph={{ rows: 3 }} />}
                    </div>
                  );
                }
          }
          onSearch={handleSearch}
          onPopupScroll={handleScroll}
          loading={loading}
          className='absolute left-0 top-0 w-full flex-1 border-0'
          prefixCls='prefix-select'
          suffixIcon={
            loading ? (
              <Spin spinning />
            ) : props.showSearch ? (
              <LoupIcon className='h-5 w-5 text-colorTextPlaceholder' />
            ) : (
              <ArrowDownIcon className='h-[10px] w-[10px] text-colorTextBase' />
            )
          }
        />
      </div>
    );
  }

  return (
    <SelectAntd
      {...props}
      dropdownRender={
        props?.dropdownRender
          ? props.dropdownRender
          : (menu) => {
              return (
                <div>
                  {menu}
                  {loading && <Skeleton active title={false} paragraph={{ rows: 3 }} />}
                </div>
              );
            }
      }
      onSearch={handleSearch}
      onPopupScroll={handleScroll}
      loading={loading}
      suffixIcon={
        loading ? (
          <Spin spinning />
        ) : props.showSearch ? (
          <LoupIcon className='h-5 w-5 text-colorTextPlaceholder' />
        ) : (
          <ArrowDownIcon className='h-[10px] w-[10px] text-colorTextBase' />
        )
      }
    />
  );
};
export default Select;
